// extracted by mini-css-extract-plugin
export default {"loaderContainer":"Loader_loaderContainer__m93I9","loader":"Loader_loader__zlzGL","animloader":"Loader_animloader__40JHE"};